import __request__ from "routing/request";
export function list(requestOptions) {
  return __request__("GET", "/system/inputs", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, setup_wizard = false, requestOptions) {
  return __request__("POST", "/system/inputs", JSONbody, { "setup_wizard": setup_wizard }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function diagnostics(inputId, requestOptions) {
  return __request__("GET", `/system/inputs/diagnostics/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function pipelineMetadataBulk(JSONbody, requestOptions) {
  return __request__("POST", "/system/inputs/meta/retrieve", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function pipelineMetadata(inputId, requestOptions) {
  return __request__("GET", `/system/inputs/meta/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(sort = "title", page = 1, per_page = 50, query, filters, order = "asc", requestOptions) {
  return __request__("GET", "/system/inputs/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getReferences(inputId, requestOptions) {
  return __request__("GET", `/system/inputs/references/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPipelineRulesPage(inputId, sort = "rule", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/system/inputs/routing_rules/pipeline/${inputId}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getStreamRulesPage(inputId, sort = "stream", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/system/inputs/routing_rules/streams/${inputId}`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(inputId, requestOptions) {
  return __request__("GET", `/system/inputs/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(JSONbody, inputId, requestOptions) {
  return __request__("PUT", `/system/inputs/${inputId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function terminate(inputId, requestOptions) {
  return __request__("DELETE", `/system/inputs/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
